export const REPORT_VISIBILITY_DIALOG_VARIANT = "report-visibility";

export const OFF_PLATFORM_CONTRACT_TYPE = "SELF_FINANCE_WITH_INVOICE_OFF_PLATFORM";

export interface ReportVisibilityType {
  value: string;
  label: string;
  contractType?: string;
}

export const REPORT_VISIBILITY_TYPES: ReportVisibilityType[] = [
  { value: "funding_report", label: "Funding Report" },
  { value: "ar_report", label: "AR Report" },
  { value: "open_ar_report", label: "Open AR Report" },
  { value: "debtor_aging_by_bucket", label: "Debtor Aging" },
  { value: "settlement_report", label: "Invoice Settlement" },
  { value: "chargeback_giveback_report", label: "Chargeback / Giveback Report" },
  { value: "self_finance_report", label: "Self-Finance Funding Report" },
  { value: "wallet_transaction", label: "Wallet Transaction Report" },
  {
    value: "off_platform_self_finance_report",
    label: "Off-Platform Funding Report",
    contractType: OFF_PLATFORM_CONTRACT_TYPE
  }
];

export const isReportVisible = (
  reportVisibility: Record<string, boolean>,
  value: string
): boolean => reportVisibility[value] !== false;

export const enabledReportCount = (
  reportVisibility: Record<string, boolean> = {}
): number =>
  REPORT_VISIBILITY_TYPES.filter(type =>
    isReportVisible(reportVisibility, type.value)
  ).length;
